module.exports = __webpack_public_path__ + "img/feature-1-banner.9221856b.png";